import { useEffect } from "react";

const useAutoScroll = (hasInitialized: boolean, renderBlocks: any[]) => {
    useEffect(() => {
      if (hasInitialized && renderBlocks.length > 0) {
        // Use setTimeout to ensure DOM is fully updated before scrolling
        setTimeout(() => {
          // Try window scroll first
          window.scrollTo({
            top: document.body.scrollHeight,
            behavior: "smooth"
          });
          
          // Fallback: scroll the last element into view
          const lastElement = document.querySelector(".recoEngine__page > *:last-child");
          if (lastElement) {
            lastElement.scrollIntoView({ behavior: "smooth", block: "end" });
          }
        }, 200);
      }
    }, [hasInitialized, renderBlocks.length]);
  };

export default useAutoScroll;